import {Component, Input, OnInit, Output, EventEmitter, ViewChild, ElementRef, PLATFORM_ID, Inject} from '@angular/core';
import {isPlatformServer} from '@angular/common';
import lottie from 'lottie-web';


@Component({
  selector: 'myvf-ui-lottie',
  template: `
    <div #lavContainer [ngStyle]="{'width': viewWidth, 'height': viewHeight, 'overflow':'hidden', 'margin': '0 auto'}"></div>
  `
})

export class LottieComponent implements OnInit {

  @Input() options: any;
  @Input() width: number;
  @Input() height: number;

  @Output() animCreated: any = new EventEmitter();

  @ViewChild('lavContainer', { static: true }) lavContainer: ElementRef;

  public viewWidth: string;
  public viewHeight: string;
  private _options: any;
  public anim: any;

  constructor(
    @Inject(PLATFORM_ID) private platformId: string
  ) {
  }

  ngOnInit() {
  	if (isPlatformServer(this.platformId)) {
  		return;
  	}

  	this._options = {
  		container: this.lavContainer.nativeElement,
  		renderer: this.options.renderer || 'svg',
  		loop: this.options.loop !== false,
  		autoplay: this.options.autoplay !== false,
  		autoloadSegments: this.options.autoloadSegments !== false,
  		animationData: this.options.animationData,
  		path: this.options.path || '',
  		rendererSettings: this.options.rendererSettings || {}
  	};

  	this.viewWidth = this.width ? this.width + 'px' : '100%';
  	this.viewHeight = this.height ? this.height + 'px' : '100%';

  	this.anim = lottie.loadAnimation(this._options);

  	this.animCreated.emit(this.anim);
  }

  stop() {
  	this.anim.stop();
  }

  play() {
  	this.anim.play();
  }

  pause() {
  	this.anim.pause();
  }

  setSpeed(speed: number) {
  	this.anim.setSpeed(speed);
  }
}
